import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Tabs, Tab } from "@material-ui/core";
import Layout from "../../../layout";
import TabPanel from "../../../components/TabPanel";
import Referrals from "./Referrals";
// import Applications from "./Applications";
import Recommended from "./Recommended";

import AllJobs from "./AllJobs";
import SearchResult from "./SearchResult";
import { useSelector } from "react-redux";
import ReactTooltip from "react-tooltip";
import { useTourGuide } from "../../../hooks/useTourGuide";
import ProHunterTrialBanner from "../../../components/ProHunterTrialBanner";
import { useProHunterTrial } from "../../../hooks/queries";

// import MyJobs from './MyJobs';
import "./index.scss";
import Joyride, { STATUS } from "react-joyride";

const Home = () => {
  useTourGuide(); // Auto-show chatbot tour on first visit
  const history = useHistory();
  const { search } = useLocation();
  const initialTab = new URLSearchParams(search).get('tab') === 'recommended' ? 1 : 0;
  const [value, setValue] = useState(initialTab);
  const { userData } = useSelector((store) => store.auth);
  const { searchedTerm, isSearchLoading } = useSelector(({ job }) => job);
  const [showIntro, setShowIntro] = useState(true);
  const [showTrialBanner, setShowTrialBanner] = useState(false);

  const [toursteps, setTourSteps] = useState([
    {
      target: ".joyride-post-job",
      content: "Publish a new job to referral or recruiter marketplaces",
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: ".joyride-all-jobs",
      content: "See all available jobs. You can Save, Like, Refer and Apply ",
      placement: "bottom",
    },
    {
      target: ".joyride-recommended-jobs",
      content: "See jobs we think may catch your attention",
      placement: "bottom",
    },

    {
      target: ".joyride-refer-candidate",
      content: "To refer a candidate to a Job and earn if they get hired",
    },
    {
      target: ".joyride-request-apply-candidate",
      content: "To Apply to a Job, Simple Click here",
    },
    {
      target: ".joyride-become-recruiter",
      content:
        "Your first step in joining the largest network of recruiters in the world!",
    },
  ]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (userData?.provider) {
      history.replace("/myjobs");
    }
  }, [userData, history]);

  useEffect(() => {
    const userId = userData?.id?.toString() || 'default';
    setShowIntro(localStorage.getItem(`showintro_${userId}`));
  }, [userData]);

  const { data: trialData } = useProHunterTrial(Boolean(userData?.id));

  useEffect(() => {
    if (trialData !== undefined) {
      setShowTrialBanner(Boolean(trialData?.eligible && trialData?.payment_rail === "stripe"));
    }
  }, [trialData]);

  return (
    <Layout>
      <ReactTooltip delayHide={1000} />
      {isSearchLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "400px",
            flexDirection: "column",
          }}
        >
          <div
            className="search-spinner-container"
            style={{ marginBottom: "16px" }}
          >
            <div className="spinner-ring"></div>
          </div>
          <p style={{ color: "#666", fontSize: "16px" }}>
            Searching for jobs...
          </p>
        </div>
      )}
      {!isSearchLoading && searchedTerm && <SearchResult />}
      {!isSearchLoading && !searchedTerm && (
        <>
          {showTrialBanner && <ProHunterTrialBanner />}

          <Tabs indicatorColor="primary" value={value} onChange={handleChange}>
            <Tab
              label="All Jobs"
              data-tip="Browse jobs to save, refer, or apply. Update your profile country to see local jobs"
              data-place="bottom"
            />
            <Tab
              label="Recommended Jobs"
              data-tip="See jobs we think  may catch your attention"
              data-place="bottom"
            />
            {/* <Tab label="My Applications" /> */}
            <Tab
              label="WB Business Referral"
              data-tip="See your private referral jobs shared by your contacts at specific organizations"
              data-place="bottom"
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <AllJobs />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Recommended />
          </TabPanel>
          {/* <TabPanel value={value} index={2}>
              <Applications />
            </TabPanel> */}
          <TabPanel value={value} index={3}>
            <Referrals />
          </TabPanel>
        </>
      )}
    </Layout>
  );
};

export default Home;
